export default "__VITE_ASSET__CDSDQ3hr__"